module.exports = __webpack_public_path__ + "img/sauda.0e70451f.jpg";